import React from "react";
import { Heart, Users, Shield, Eye, Scale, Gem } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";

const services = [
  { icon: Heart, title: "Retour Affectif", desc: "Un rituel d'amour puissant pour faire revenir l'être aimé, réparer un couple brisé et raviver durablement la flamme entre vous." },
  { icon: Shield, title: "Sorcellerie Africaine", desc: "La magie traditionnelle d'Afrique pour débloquer les situations difficiles, attirer la chance et apaiser les conflits familiaux." },
  { icon: Eye, title: "Désenvoûtement", desc: "Un nettoyage spirituel profond contre le mauvais œil, les malédictions, la malchance à répétition et les sorts jetés contre vous." },
  { icon: Scale, title: "Justice & Héritage", desc: "Des rituels pour favoriser une issue positive dans vos affaires judiciaires, litiges et problèmes de succession." },
  { icon: Users, title: "Maraboutage d'Amour", desc: "Renforcez les liens de votre couple ou de votre mariage, retrouvez la fidélité et éloignez les rivaux qui menacent votre bonheur." },
  { icon: Gem, title: "Protection Marabout", desc: "Une protection spirituelle durable pour vous, votre famille, votre maison et votre travail, partout à La Réunion." },
];

const Services = () => (
  <section id="services" className="py-24 md:py-32 bg-[#09090b]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle eyebrow="Mes services" title="Travaux de" gold="Maraboutage"
        subtitle="La puissance de la tradition africaine au service de votre amour, de votre chance et de votre sérénité." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="services-grid">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 120}>
            <div className="lux-card group h-full p-8" data-testid={`service-card-${i}`}>
              <div className="w-14 h-14 rounded-full border border-amber-500/40 flex items-center justify-center mb-6 group-hover:bg-amber-500/10 transition-colors duration-500">
                <s.icon className="w-6 h-6 text-amber-400" strokeWidth={1.5} />
              </div>
              <h3 className="font-heading text-xl text-amber-100 mb-3">{s.title}</h3>
              <p className="text-zinc-400 leading-relaxed text-sm md:text-base">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
